import React from 'react';
import { formatRouteDuration, formatRouteDistance } from '../../utils/routeParser';

/**
 * RouteSummary - Exact Figma specs:
 * Outer: flex column, gap 2px, padding 16px 0, margin 0 8px
 * Inner headline: flex row, padding 16px 0, gap 8px, align-self stretch
 * Typography: B1/body1_semibold for time+distance, B2/body2_default for via
 */
const RouteSummary = ({ distance, duration, summary, sourceName, sourceAddress }) => {
  const durationText = formatRouteDuration(duration);
  const distanceText = formatRouteDistance(distance);

  return (
    <div className="route-summary">
      {/* Duration + Distance + Via in one block */}
      <div className="route-summary-headline">
        <div className="route-summary-info">
          <span className="route-summary-duration">{durationText} ({distanceText})</span>
          {summary && (
            <span className="route-summary-via">via {summary}</span>
          )}
        </div>
      </div>

      {/* Your Location */}
      <div className="route-summary-location">
        <div className="route-summary-source-dot">
          <img src="/icons/location-on.svg" alt="" className="route-summary-source-icon" />
        </div>
        <div className="route-summary-location-text">
          <span className="route-summary-location-name">Your Location</span>
          <span className="route-summary-location-address">
            {sourceAddress || sourceName || ''}
          </span>
        </div>
      </div>
    </div>
  );
};

export default RouteSummary;
